import * as angular from 'angular';

import { ComponentDefinition } from '@models/index';
import { validateEmailList } from '../../common/helpers/validateEmailList';

class EmailAddressListController implements angular.IComponentController {
    addressList: string;
    formController: angular.IFormController;
    readonly fieldName = 'addressListProperty';

    static $inject = [];
    
    validateEmail() {
        const userEmails = this.formController[this.fieldName].$viewValue as string;
        const isEmailValid = validateEmailList(userEmails);
        this.formController[this.fieldName].$setValidity('invalid', isEmailValid);
    }
}

export const wtEmailAddressList: ComponentDefinition = {
    componentId: 'wtEmailAddressList',
    controller: EmailAddressListController,
    template: require('./emailAddressList.component.html'),
    controllerAs: 'vm',
    bindings: {
        addressList: '=',
        formController: '<'
    }
};